import { Component } from '@angular/core';

@Component({
    selector: 'app-image-cropper',
    templateUrl: './image-cropper.component.html',
    styleUrls: ['./image-cropper.component.scss'],
    standalone: false
})
export class ImageCropperComponent {

}
